import type { SVGProps } from "react";

function LexiconLogo(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      id="svg1"
      width="533.487"
      height="350.611"
      version="1.1"
      viewBox="0 0 141.152 92.766"
      {...props}
    >
      <g id="layer1" transform="translate(-30.861 -99.894)">
        <path
          id="rect14"
          fill="#fff"
          fillOpacity="1"
          stroke="#ff862f"
          strokeWidth="1.595"
          d="M31.659 110.914c23.534-15.202 46.614-11.557 69.503 0v80.344c-21.81-12.956-45.102-11.777-69.503 0z"
        ></path>
        <path
          id="rect14-6"
          fill="#fff"
          fillOpacity="1"
          stroke="#ff862f"
          strokeWidth="1.595"
          d="M101.713 110.75c23.534-15.202 46.614-11.557 69.503 0v80.345c-21.811-12.956-45.102-11.777-69.503 0z"
        ></path>
        <g
          id="rect26"
          fill="#ff862f"
          fillOpacity="0"
          fillRule="evenodd"
          stroke="#ff862f"
          strokeOpacity="1"
          opacity="1"
          transform="matrix(1.1259 0 0 .80567 61.516 94.544)"
        >
          <path
            id="path26"
            fill="#ff862f"
            fillOpacity="1"
            fillRule="evenodd"
            stroke="#ff862f"
            strokeOpacity="1"
            strokeWidth="0.481"
            d="m16.578 11.335 14.824 6.763.293 27.131c-5.75-17.934-10.443-12.319-14.822 0z"
            baselineShift="baseline"
            display="inline"
            overflow="visible"
            stopColor="#000"
            stopOpacity="1"
            vectorEffect="none"
          ></path>
        </g>
        <path
          id="text31"
          fill="#ff862f"
          fillRule="evenodd"
          strokeWidth="3.832"
          d="M65.001 130.783v13.298h5.82v-5.49h2.199v7.7H60.04v-2.21h2.28v-13.298h-2.28v-2.21h7.242v2.21zm22.775 9.947H77.417q.224 1.775 1.376 2.81 1.152 1.023 2.822 1.023 1.223 0 2.27-.505 1.046-.506 1.751-1.553l2.14.965q-1.011 1.575-2.657 2.386-1.634.8-3.563.8-1.999 0-3.55-.835-1.553-.835-2.423-2.328-.858-1.493-.858-3.363 0-1.857.846-3.35.859-1.494 2.34-2.329 1.482-.846 3.269-.846 1.952 0 3.398.87 1.458.858 2.293 2.469.835 1.599.905 3.786m-6.549-5.103q-1.376 0-2.41.929-1.035.917-1.329 2.434h7.737q-.341-1.517-1.447-2.434-1.105-.929-2.551-.929m12.475.482 2.234 2.434 2.081-2.434H96.76v-2.175h5.832v2.175h-2.046l-3.257 3.704 3.928 4.315h1.375v2.164H96.76v-2.164h1.588l-2.458-2.798-2.422 2.798h1.587v2.164h-5.973v-2.164h1.8l3.715-4.174-3.516-3.845h-1.693v-2.175h5.808v2.175z"
          aria-label="Lex"
          fontFamily="Rockwell"
          fontSize="24.08"
          transform="scale(.9302 1.07503)"
        ></path>
        <path
          id="text32"
          fill="#ff862f"
          fillRule="evenodd"
          strokeWidth="0.301"
          d="M111.822 138.404q0 .6-.435 1.035t-1.035.435-1.023-.435-.423-1.035.423-1.035 1.023-.435q.623 0 1.047.423.423.424.423 1.047m1.74 14.356v2.164h-6.243v-2.164h1.928v-8.019h-1.928v-2.175h4.362v10.194zm10.982-9.3v-.894h2.164v4.68h-2.164q-.141-1.352-1.082-2.058-.94-.717-2.175-.717-1.058 0-1.905.564-.834.565-1.293 1.529t-.459 2.105q0 1.94 1.035 3.174 1.035 1.223 2.728 1.223 2.622 0 3.704-2.434l2.022.964q-1.705 3.692-5.832 3.692-1.846 0-3.28-.87-1.435-.87-2.223-2.387-.776-1.516-.776-3.362 0-1.811.788-3.293.8-1.481 2.187-2.304 1.388-.835 3.092-.835 2.023 0 3.47 1.223m17.05 5.303q0 1.799-.86 3.292-.858 1.493-2.339 2.363-1.482.87-3.28.87-1.858 0-3.352-.87t-2.328-2.363q-.823-1.493-.823-3.292 0-1.882.823-3.363.835-1.482 2.317-2.317 1.481-.846 3.362-.846 1.823 0 3.304.894 1.482.881 2.329 2.375.846 1.493.846 3.257m-6.48 4.162q1.082 0 1.988-.564.905-.565 1.41-1.517.506-.953.506-2.081 0-1.106-.505-2.058-.506-.952-1.411-1.529-.906-.587-2.011-.587-1.082 0-1.987.576-.905.564-1.423 1.528-.517.964-.517 2.07t.517 2.069 1.435 1.529 1.998.564m20.083-6.314v6.15h2.07v2.163h-4.504v-8.16q0-1.164-.34-1.67-.33-.505-1.094-.505-1.623 0-3.645 1.599v6.572h2.128v2.164h-6.702v-2.164h2.175v-8.019h-2.175v-2.175h4.574v1.493q2.269-1.657 4.268-1.657 1.658 0 2.446 1.022.8 1.023.8 3.187"
          aria-label="icon"
          fontFamily="Rockwell"
          fontSize="24.08"
          transform="scale(.98573 1.01448)"
        ></path>
      </g>
    </svg>
  );
}

export default LexiconLogo;
